module.exports = __webpack_public_path__ + "static/media/exam-papers-plus-logo.21ed707c.svg";